import { render, staticRenderFns } from "./BatchMove.template.vue?vue&type=template&id=6b859350&scoped=true&"
var script = {}
import style0 from "./BatchMove.template.vue?vue&type=style&index=0&id=6b859350&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b859350",
  null
  
)

export default component.exports